import SmallScreenHeader from "../SmallScreenHeader";

const Facets = () => (
  <>
    <SmallScreenHeader />
  </>
);

export default Facets;
